import React, { useMemo } from 'react';
import { VirtualSlotsPlaceholderContext, VirtualSlotsPlaceholderHighlightContext, VirtualSlotsPlaceholderHostId, } from './slotsPlaceholderContext';
export function withSlotsPlaceholders(Component) {
    return (props) => {
        const { slots, compPreviewState, id, ...otherProps } = props;
        const highlightData = useMemo(() => {
            if (!compPreviewState) {
                return {};
            }
            const [slotId, highlightState] = compPreviewState.split('-');
            return {
                [slotId]: highlightState,
            };
        }, [compPreviewState]);
        return (React.createElement(VirtualSlotsPlaceholderHostId.Provider, { value: id },
            React.createElement(VirtualSlotsPlaceholderContext.Provider, { value: slots },
                React.createElement(VirtualSlotsPlaceholderHighlightContext.Provider, { value: highlightData },
                    React.createElement(Component, { ...otherProps })))));
    };
}
//# sourceMappingURL=withSlotsPlaceholders.js.map